import { Modal, Result, Button } from 'antd';
import PublishIcon from '@mui/icons-material/Publish';
import { primaryShades } from '../../../theme/theme';

const ConfirmPublishChangesModal = ({
    isOpen,
    onClose,
    onConfirm,
    catalogName,
    isLoading = false
}) => {
    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            centered
            footer={null}
            closable={!isLoading}
            maskClosable={!isLoading}
        >
            <Result
                icon={<PublishIcon style={{ color: primaryShades.primary300, fontSize: 64 }} />}
                title="Publish Changes"
                subTitle={`Are you sure you want to publish the changes to "${catalogName || 'Untitled'}"? This will update the published catalog with all modifications from the draft and delete the draft version. A notification will be sent to confirm the publication. This action is irreversible.`}
                extra={[
                    <Button
                        key="publish"
                        type="primary"
                        onClick={onConfirm}
                        loading={isLoading}
                        disabled={isLoading}
                    >
                        Publish Changes
                    </Button>,
                    <Button
                        key="cancel"
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        Cancel
                    </Button>
                ]}
            />
        </Modal>
    );
};

export default ConfirmPublishChangesModal;
